{
    "filter_button__text": "Filter",
    "filter_search__aria_label": "Search in list",
    "filter_modal__title": "Filters",
    "remove_all": "Remove all",
    "quick_filters__customers_my_plus_customers": "🚀 Largest Expansion Potential",
    "quick_filters__customers_my_minus_customers": "⚠️ Strongest Churn",
    "quick_filters__orders_my_open_orders": "Open orders",
    "quick_filters__orders_my_billed_orders": "Billed orders",
    "quick_filters__quotes_my_open_quotes": "Open quotes",
    "date_range_filter__newer_than": "is newer than",
    "date_range_filter__older_than": "is older than",
    "date_range_filter__range_mode": "is within the period",
    "date_range_filter__please_select": "Please select",
    "date_range_filter__unit_label": "Unit",
    "date_range_filter__unit_days": "Days",
    "date_range_filter__unit_weeks": "Weeks",
    "date_range_filter__unit_months": "Months",
    "price_range_filter__than": "than",
    "price_range_filter__is": "is",
    "price_range_filter__greater": "Greater",
    "price_range_filter__smaller": "Smaller",
    "save_view": "Save view",
    "save_view_dialog__title": "Save view",
    "save_view_dialog__name_placeholder": "Enter name",
    "save_view_dialog__visibility_label": "Who should see the view?",
    "save_view_dialog__visibility_only_me": "Only me",
    "save_view_dialog__visibility_team": "Everyone in my team",
    "save_view_dialog__clear_all": "Clear all",
    "save_view_dialog__cancel": "Cancel",
    "save_view_dialog__save": "Save view",
    "save_view_dialog__name_required": "Please give this view a name",
    "save_view_dialog__name_too_long": "View name must be 255 characters or less",
    "saved_views__all_views": "All Views",
    "saved_views__my_views": "My Views",
    "saved_views__shared_views": "Shared Views",
    "saved_views__edit": "Edit",
    "saved_views__delete": "Delete",
    "saved_views__delete_confirmation_title": "Delete filter view",
    "saved_views__delete_confirmation_description": "Are you sure you want to delete this filter view? This action cannot be undone.",
    "edit_view_dialog__title": "Edit view",
    "edit_view_dialog__update": "Update view"
}
